export class IntegratedFtpValueContainer {
    constructor(public PartnerId?: number, public Value?: string) { }
}